import React from 'react';
import { TrendingUp, Shield, Lock, Wallet } from 'lucide-react';
import { solutions } from '../../data/mock';

const iconMap = {
  TrendingUp,
  Shield,
  Lock,
  Wallet,
};

const Solutions = () => {
  return (
    <section id="solutions" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-blue-400 font-medium text-sm tracking-wider uppercase mb-4 block">
            Solutions
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            Built for
            <span className="text-blue-400"> Enterprise Scale</span>
          </h2>
          <p className="text-slate-400 text-lg">
            Our solutions are engineered to meet the demanding requirements of 
            modern enterprise operations.
          </p>
        </div>

        {/* Solutions Cards */}
        <div className="grid md:grid-cols-2 gap-8">
          {solutions.map((solution, index) => {
            const IconComponent = iconMap[solution.icon];
            return (
              <div
                key={solution.id}
                className="group relative overflow-hidden rounded-3xl bg-gradient-to-br from-slate-800/80 to-slate-800/40 border border-slate-700/50 hover:border-blue-500/30 transition-all duration-500"
              >
                <div className="p-8 lg:p-10">
                  <div className="flex items-start gap-6">
                    {/* Icon */}
                    <div className="w-16 h-16 bg-blue-500/10 rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:bg-blue-500/20 transition-colors duration-300">
                      {IconComponent && (
                        <IconComponent className="w-8 h-8 text-blue-400" />
                      )}
                    </div>

                    {/* Content */}
                    <div>
                      <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-blue-300 transition-colors">
                        {solution.title}
                      </h3>
                      <p className="text-slate-400 text-lg leading-relaxed">
                        {solution.description}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Decorative Elements */}
                <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-blue-500/5 rounded-full blur-2xl group-hover:bg-blue-500/10 transition-colors duration-500"></div>
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-blue-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
            );
          })}
        </div>

        {/* Stats Row */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { value: '99.99%', label: 'Uptime SLA' },
            { value: '< 50ms', label: 'Response Time' },
            { value: '24/7', label: 'Support' },
            { value: '1M+', label: 'Transactions/Day' },
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl lg:text-4xl font-bold text-blue-400 mb-2">
                {stat.value}
              </div>
              <div className="text-slate-500 text-sm font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
